// This strategy is used to keep the iOS Webview alive and let js code run in background
// by calling setOrientationProperties every second.
// This is a workaround for a known issue where iOS Webview pauses javascript execution after a few seconds without activity.
// See https://jira.ogury.io/browse/SL3-4697 for more details.
import { isFeatureEnable } from 'common/js/features-enabling';
import { FormatContext, ILoadingStrategy } from './loading-strategy-factory';

const KEEP_ALIVE_INTERVAL = 1000; // in ms

export class iOSWebviewKeepAliveStrategy implements ILoadingStrategy {
  setIntervalHandle: ReturnType<typeof setInterval> | null = null;

  isRunnable(formatContext: any): boolean {
    return isFeatureEnable('sdkiOSKeepAlive');
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    return formatContext;
  }

  onAfterRender(formatContext: FormatContext): void {
    if (this.setIntervalHandle) {
      clearInterval(this.setIntervalHandle);
      this.setIntervalHandle = null;
    }
  }

  onBeforeRender(formatContext: FormatContext): void {
    if (!window.mraid || !window?.mraid?.setOrientationProperties) {
      return;
    }

    let orientation = 'auto';
    if (formatContext.config?.orientation) {
      orientation = formatContext.config.orientation;
    }

    this.setIntervalHandle = setInterval(() => {
      if (window.mraid && window.mraid.setOrientationProperties) {
        if (orientation !== 'auto') {
          window.mraid.setOrientationProperties({
            allowOrientationChange: false,
            forceOrientation: orientation as MRAIDOrientation
          });
        } else {
          window.mraid.setOrientationProperties({
            allowOrientationChange: true,
            forceOrientation: 'none'
          });
        }
      }
    }, KEEP_ALIVE_INTERVAL);
  }

  onResize(formatContext: FormatContext): void {}
}
